/* unplugin-vue-components disabled */import script from "./homepageAnnouncement.vue?vue&type=script&lang=js"
export * from "./homepageAnnouncement.vue?vue&type=script&lang=js"

import "./homepageAnnouncement.vue?vue&type=style&index=0&id=d94b92b6&lang=scss"

const __exports__ = script;

export default __exports__